import classes from "./Account.module.css";
import React, { useState } from "react";
import { connect } from "react-redux";

import { auth } from "../../firebase";
import * as actions from "../../store/actions";

import AccountSettings from "./AccountSettings/AccountSettings";
import PremiumCategories from "./PremiumCategories/PremiumCategories";
import Hamburger from "./Hamburger/Hamburger";
import EmailSettings from "./EmailSettings/EmailSettings";

const Account = ({ selectPaidCategory, onUpdatePurchased }) => {
  const [page, setPage] = useState("account");
  const [showMenu, setShowMenu] = useState(false);

  const hamburgerClicked = () => {
    if (showMenu) {
      setShowMenu(false);
    } else {
      setShowMenu(true);
    }
  };

  const switchPage = (page) => {
    setPage(page);
    setShowMenu(false);
  };

  const logout = () => {
    auth.signOut();
    onUpdatePurchased([]);
  };

  let heading = "Account settings";
  if (page === "categories") {
    heading = "Premium categories";
  }
  return (
    <div className={classes.Account}>
      <div className={classes.MobileMenu}>
        <div className={classes.MobileMenuBar}>
          <h1>{heading}</h1>
          <Hamburger clicked={hamburgerClicked} active={showMenu} />
        </div>
        <ul style={showMenu ? { top: "50px" } : { top: "-90px" }}>
          <li className={page === "account" ? classes.Active : null}>
            <button onClick={() => switchPage("account")}>
              Account settings
            </button>
          </li>
          <li className={page === "categories" ? classes.Active : null}>
            <button onClick={() => switchPage("categories")}>
              Premium categories
            </button>
          </li>
          <li className={page === "email" ? classes.Active : null}>
            <button onClick={() => switchPage("email")}>Email settings</button>
          </li>
          <li>
            <button onClick={logout}>Log out</button>
          </li>
        </ul>
      </div>
      <div className={classes.DesktopMenu}>
        <ul>
          <li className={page === "account" ? classes.Active : null}>
            <button onClick={() => switchPage("account")}>
              Account settings
            </button>
          </li>
          <li className={page === "categories" ? classes.Active : null}>
            <button onClick={() => switchPage("categories")}>
              Premium categories
            </button>
          </li>
          <li className={page === "email" ? classes.Active : null}>
            <button onClick={() => switchPage("email")}>Email settings</button>
          </li>
          <li>
            <button onClick={logout}>Log out</button>
          </li>
        </ul>
      </div>
      <div className={classes.AccountContainer}>
        {page === "account" ? (
          <AccountSettings />
        ) : page === "categories" ? (
          <PremiumCategories selectPaidCategory={selectPaidCategory} />
        ) : (
          <EmailSettings />
        )}
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  onUpdatePurchased: (purchased) =>
    dispatch(actions.updatePurchased(purchased)),
});

export default connect(null, mapDispatchToProps)(Account);
